<!-- Header -->
<h1 mat-dialog-title>{{ config.title }}</h1>

<!-- Content -->
<div mat-dialog-content>
  <p [innerHTML]="config.content"></p>
</div>

<!-- Actions -->
<div mat-dialog-actions align="end">

  <button mat-button *ngIf="!config.disableClose" tabindex="-1" (click)="dialogRef.close('cancel')">
    {{ 'cancel' | translate }}
  </button>
  
  <button mat-flat-button *ngFor="let action of config.actions" (click)="dialogRef.close(action.action)" tabindex="-1" [color]="config.type">
    <mat-icon *ngIf="action.icon">
      {{ action.icon }}
    </mat-icon>
    {{ action.label }}
  </button>

</div>
